"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Yup = __importStar(require("yup"));

require("./validators");

var ibanInput = {};

for (var index = 1; index < 8; index++) {
  ibanInput["iban_field_" + index] = {
    placeholder: index == 1 ? 'FR--' : '----',
    schema: Yup.string().matches(/^[a-zA-Z0-9]+$/, 'Valeur incorrecte').min(index < 7 ? 4 : 3, 'Votre saisie est incomplète, merci de renseigner le champ ci-dessus.').required()
  };
}

exports.default = ibanInput;